<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import BaseContent from "@/components/BaseContent.vue";
import BaseSwitch from "@/components/BaseSwitch.vue";
import { Link } from "@inertiajs/vue3";
import { ref } from "vue";

defineProps<{
  linkSkills: object;
}>();

const level = ref(true);

const emit = defineEmits(["scrollToLinkPartners"]);
</script>

<template>
  <BaseCard :footer="{ class: 'hover:cursor-pointer', hoverLightUp: true }">
    <template #heading>Link Skills</template>

    <template #headerActions>
      <BaseSwitch
        v-model="level"
        class="float-right text-sm"
        left="Lv. 1"
        right="Lv. 10"
      />
    </template>

    <template #footer>
      <div class="-m-4 p-4" @click="$emit('scrollToLinkPartners')">
        Show Link Partners
        <i-fa6-solid-arrow-down class="ml-1 inline" />
      </div>
    </template>

    <BaseContent class="!block">
      <ul class="ml-0 list-none space-y-1">
        <li v-for="linkSkill in linkSkills.filter((e) => e !== null)">
          <Link
            :data="{
              link_skills: [linkSkill.id],
            }"
            :href="route('characters.index')"
            class="font-medium"
            >{{ linkSkill.name }}
          </Link>
          <br />
          <span class="text-sm">{{
            linkSkill.lvs[level ? 9 : 0].description
          }}</span>
        </li>
      </ul>
    </BaseContent>
  </BaseCard>
</template>

<style scoped></style>
